'use client';

import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

type LogoBarRevealProps = {
  className?: string;
  delaySeconds?: number;
  children: React.ReactNode;
};

export default function LogoBarReveal({
  className,
  delaySeconds = 4,
  children,
}: LogoBarRevealProps) {
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  // Screen size detection for lg breakpoint (1024px)
  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <motion.div
      className={className}
      initial={isLargeScreen ? { opacity: 0, y: 20 } : { opacity: 1, y: 0 }}
      animate={{ opacity: 1, y: 0 }}
      transition={isLargeScreen ? { duration: 0.8, ease: 'easeOut', delay: delaySeconds } : { duration: 0 }}
    >
      {children}
    </motion.div>
  );
}


